import api from './api';

export interface Setting {
  key: string;
  value: string;
  label: string;
  description: string;
  type: 'string' | 'number' | 'boolean' | 'select';
  options?: string[];
  category: string;
}

export interface SettingsResponse {
  success: boolean;
  data: Record<string, Setting[]>;
}

export async function fetchSettings(): Promise<Record<string, Setting[]>> {
  const res = await api.get<SettingsResponse>('/v1/admin/settings');
  return res.data.data;
}

export async function updateSetting(category: string, key: string, value: string): Promise<Setting> {
  const res = await api.put<{ success: boolean; data: Setting }>(
    `/v1/admin/settings/${encodeURIComponent(category)}/${encodeURIComponent(key)}`,
    { value }
  );
  return res.data.data;
}
